module.exports = __webpack_public_path__ + "files/b0acce9f0a6b0f96f9a5baf56d013673.png";